<template>
	<div class="title-with-right-button-area">
		<div class="title">
			<h1 v-if="viewType === 'send'" v-text="writeType === 'reply' ? '답장하기' : '쪽지쓰기'">쪽지쓰기</h1>
			<h1 v-else v-text="writeType === 'modify' ? '1:1온라인상담 수정하기' : '1:1온라인상담 등록하기'" class="consult-title">
				1:1온라인상담 등록하기
			</h1>
		</div>
		<div class="right-btn mobile-hide">
			<button class="grayBtn" @click="$router.go(-1)">취소</button>
			<button class="greenBtn" @click.prevent.stop="doSubmit()" v-text="viewType === 'consult' ? (seqNo == null ? '등록' : '수정') : '보내기'">
				보내기
			</button>
		</div>
		<div class="basic-container" v-if="viewType === 'send'">
			<div class="qna-area">
				<section>
					<div class="block">
						<label>제목</label>
						<input type="text" v-model="contentTitle" placeholder="입력해주세요." />
					</div>
				</section>

				<section>
					<div class="block">
						<label>받은사람</label>
						<input
							class="send-input"
							type="text"
							v-if="isCompany"
							disabled
							:value="receiveUserData ? receiveUserData.countryNm + ' / ' + receiveUserData.regionNm + ' ' + receiveUserData.oktaUserNmKor : ''"
						/>
						<input
							:class="writeType === 'reply' ? '' : 'send-input'"
							type="text"
							v-else
							disabled
							:value="receiveUserData ? receiveUserData.companyNmKor : ''"
						/>
						<button class="addresslineBtn" @click="openAddress" v-if="writeType !== 'reply'">주소록</button>
					</div>
				</section>

				<section>
					<div class="block">
						<label class="textarea-label">내용</label>
						<textarea placeholder="입력해주세요." v-model="contentBody" maxlength="300" />
					</div>
				</section>
				<div class="mobile-btn-box web-hide">
					<button class="greenLineBtn" @click="$router.go(-1)">취소</button>
					<button class="greenBtn" @click.once="doSubmit">보내기</button>
				</div>
			</div>
		</div>

		<div class="basic-container" v-if="viewType === 'consult'">
			<div class="qna-area">
				<section>
					<div class="block">
						<label>제목</label>
						<input type="text" v-model="contentTitle" placeholder="입력해주세요." />
					</div>
				</section>

				<section>
					<div class="block">
						<label>문의유형</label>
						<div class="select-wrapper salary-text">
							<select name="qnaType" v-model="qnaType" ref="chargeCd" class="">
								<option value="" selected>선택해주세요</option>
								<option v-for="(codeVO, i) in qnaTypeList" :key="i" :value="codeVO.code">{{ codeVO.name }}</option>
							</select>
						</div>
					</div>
				</section>

				<section class="new-filebox">
					<div class="block">
						<label>첨부파일</label>
						<file-input-drag
							target-id="BUDS_ONLINE_CONSULT_FILE"
							target-name="BUDS_ONLINE_CONSULT_FILE"
							accept="image/jpeg,image/png"
							:on-change="addFile"
							:multiple="true"
						/>
						<!--<label v-if="fileList" class="mobile-hide"></label>
                        <div class="filelist-box" v-if="fileList != null">
              <div class="img-file-md" v-for="(fileVO, i) in fileList" v-bind:key="i">
                <a :href="CONST.API_SERVER + '/okta/file/' + fileVO.seqNo" download
                  ><div class="file-ellipsis">
                    {{ fileVO.name }}
                    <span v-if="i + 1 != fileList.length" class="ml-2 mr-2"> / </span>
                  </div></a
                >
                <img class="icon-trash trash-box" v-if="fileVO.seqNo" :src="require('../../assets/images/icon/icon-trash@2x.png')" />
              </div>
            </div>-->
						<br />
					</div>
					<div class="block pt-0">
						<label class="mobile-hide"></label>
						<div class="filelist-box">
							<div class="img-file-md" v-for="(fileVO, i) in oldFileList" v-bind:key="i">
								<a :href="CONST.API_SERVER + '/okta/file/' + fileVO.split('|')[0]" download
									><div class="">{{ fileVO.split('|')[1] }}</div></a
								>
								<img
									class="icon-trash trash-box"
									v-if="fileVO.split('|')[0]"
									:src="require('../../assets/images/icon/icon-trash@2x.png')"
									@click="delSelectFile(fileVO.split('|')[0])"
								/>
								<br />
							</div>
							<div class="filelist-box" v-if="fileList != null">
								<div class="img-file-md" v-for="(fileVO, i) in fileList" v-bind:key="i">
									<a :href="CONST.API_SERVER + '/okta/file/' + fileVO.seqNo" download
										><div class="">
											{{ fileVO.name }}
											<span v-if="i + 1 != fileList.length" class="ml-2 mr-2"> / </span>
										</div></a
									>
									<img class="icon-trash trash-box" v-if="fileVO.seqNo" :src="require('../../assets/images/icon/icon-trash@2x.png')" />
								</div>
							</div>
						</div>
					</div>
				</section>

				<section>
					<div class="block">
						<label class="textarea-label">내용</label>
						<textarea placeholder="입력해주세요." v-model="contentBody" />
					</div>
				</section>
				<div class="mobile-btn-box web-hide">
					<button class="greenLineBtn" @click="$router.go(-1)">취소</button>
					<button class="greenBtn" @click.once="doSubmit">등록</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import eventBus from '@/plugins/event-bus';
import FileInputDrag from '@/components/common/FileInputDrag';

export default {
	title: '문의 작성',
	name: 'QnaNew',
	props: ['viewType', 'seqNo', 'writeType'],
	components: { FileInputDrag },
	data: function() {
		return {
			CONST,
			eventBus,
			loginMember: null,
			contentTitle: '',
			contentBody: '',
			qnaType: '',
			fileList: null,
			oldFileList: null,
			receiveUserSeqNo: 0,
			receiveUserData: null,
			apiData: null,

			qnaTypeList: [
				{ code: 'PROGRAM', name: '프로그램' },
				{ code: 'FEE', name: '정산' },
				{ code: 'ETC', name: '기타' },
			],
		};
	},
	watch: {
		viewType: function() {
			this.listPage = 1;
			this.getBusinessList();
		},
	},
	created() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
	},
	mounted() {
		eventBus.$on(
			CONST.EVENTS.DATA_RETURN,
			function(v, param) {
				if (v === 'modalAddress') {
					if (typeof param !== 'undefined') {
						this.receiveUserData = [];
						this.receiveUserData = param;
						if (this.isCompany) {
							this.receiveUserSeqNo = Number(param.userSeqNo);
						} else {
							this.receiveUserSeqNo = Number(param.companySeqNo);
						}
					}
				}
			}.bind(this),
		);
		if (this.seqNo != null) {
			this.$nextTick(this.getBoardDetail());
		}
	},
	beforeDestroy() {
		eventBus.$off(CONST.EVENTS.DATA_RETURN);
	},
	computed: {
		isCompany() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
		isConsult() {
			return this.viewType === 'consult';
		},
	},
	methods: {
		doSubmit: function() {
			if (this.contentTitle === '') {
				alert('제목을 입력하세요.');
				return false;
			}
			if (this.isConsult && this.qnaType === '') {
				alert('문의유형을 선택해 주세요.');
				return false;
			}
			if (!this.isConsult && this.receiveUserSeqNo === 0) {
				alert('받은사람을 선택해 주세요.');
				return false;
			}
			if (this.contentBody === '') {
				alert('내용을 입력하세요.');
				return false;
			}
			let apiUrl;
			let formData = new FormData();
			formData.append('contentTitle', this.contentTitle);
			formData.append('contentBody', this.contentBody);
			if (this.isConsult) {
				apiUrl = '/api/board/onlineConsultDetailSubmit.do';
				formData.append('qnaType', this.qnaType);
				if (this.seqNo != null) formData.append('qnaSeqNo', this.seqNo);
				if (this.fileList && this.fileList.length > 0)
					for (let i = 0; i < this.fileList.length; i++) {
						formData.append('BUDS_ONLINE_CONSULT_FILE', this.fileList[i]);
					}
			} else {
				apiUrl = '/api/board/sendInbox.do';
				formData.append('receiveUserSeqNo', this.receiveUserSeqNo);
			}
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + apiUrl, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(res => {
					if (res.data.resultCode !== 0) {
						window.alert(res.data.resultMsg);
					} else {
						window.alert('저장되었습니다.');
						if (this.isConsult) {
							this.$device.pushView('qna/consult/detail/' + res.data.data.qnaSeqNo + '/true');
						} else {
							this.$device.pushView('qna/send/');
						}
						window.location.reload();
					}
				})
				.catch(e => console.error(e));
		},
		openAddress: function() {
			let body = document.getElementsByTagName('body')[0];
			body.classList.add('not-scroll');
			eventBus.$emit(CONST.EVENTS.OPEN_MODAL, 'modalAddress', '주소록');
		},
		addFile: function(e) {
			let fileInputName = e.target ? e.target.name : e.name;
			let fileInputList = e.target ? e.target.files : e.files;
			if (fileInputName === 'BUDS_ONLINE_CONSULT_FILE') {
				this.fileList = [];
				try {
					for (let i = 0; i < fileInputList.length; i++) {
						let file = fileInputList[i];
						if (file) {
							this.fileList.push(file);
						}
					}
				} catch (e) {
					console.error(e);
				}
			}
		},
		// delFile: function(file) {
		// 	if (file === 'BUDS_ONLINE_CONSULT_FILE') {
		// 		this.fileList = null;
		// 		let fileInput = document.getElementById(file);
		// 		fileInput.value = null;
		// 	}
		// },
		delSelectFile: function(idx) {
			if (confirm('삭제하시겠습니까?')) {
				let formData = new FormData();
				formData.append('seqNo', idx);
				this.$apiClient
					.getInstance()
					.post(this.$apiClient.getApiServer() + '/api/common/okta/fileDel.do', formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					})
					.then(res => {
						if (res.data.resultCode === 0) {
							alert('삭제되었습니다.');
							window.location.reload();
						} else {
							window.alert(res.data.resultMsg);
						}
					})
					.catch(e => console.error(e));
			}
			// if (file === 'BUDS_ONLINE_CONSULT_FILE') {
			// 	this.fileList.splice(idx, 1);
			// 	if (this.fileList.length > 0) {
			// 		// this.apiData.promoFile = JSON.stringify(this.promoFile);
			// 	} else {
			// 		// this.apiData.promoFile = null;
			// 		let fileInput = document.getElementById(file);
			// 		fileInput.value = null;
			// 	}
			// }
		},
		getBoardDetail: function() {
			let formData = new FormData();
			let apiUrl;
			if (this.writeType === 'modify') {
				formData.append('qnaSeqNo', this.seqNo);
				apiUrl = '/api/board/getConsultDetail.do';
			} else if (this.writeType === 'reply') {
				formData.append('seqNo', this.seqNo);
				apiUrl = '/api/board/getInboxDetail.do';
			}
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + apiUrl, formData)
				.then(res => {
					if (res.data.resultCode !== 0) {
						window.alert(res.data.resultMsg);
						this.goList();
					} else {
						this.apiData = res.data.data;
						if (this.writeType === 'modify') {
							this.contentTitle = this.apiData.contentTitle;
							this.contentBody = this.apiData.contentBody;
							this.qnaType = this.apiData.qnaType;
							if (this.apiData.consultFile && this.apiData.consultFile.length > 0) {
								this.oldFileList = this.apiData.consultFile.split(',');
							}
						} else if (this.writeType === 'reply') {
							this.receiveUserSeqNo = this.apiData.sendUserSeqNo;
							if (this.isCompany) {
								this.receiveUserData = {
									countryNm: this.apiData.countryNm,
									regionNm: this.apiData.regionNm,
									oktaUserNmKor: this.apiData.sendUserNmKor,
								};
							} else {
								this.receiveUserData = {
									companyNmKor: this.apiData.sendUserNmKor,
								};
							}
						}
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
	},
};
</script>

<style scoped></style>
